import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import LegalDocumentView from '../components/LegalDocumentView';
import { apiService } from '../services/api';
import { AboutContent, UNAVAILABLE_ABOUT } from '../types';

/**
 * The public "About Us" page — credits, municipality contacts and the
 * developer, written by a Super Admin. View-only for everyone; the edit
 * screen is a separate Super-Admin route (AboutContentPage).
 *
 * Rendered through LegalDocumentView, which shares the {heading, body}
 * section shape. The extra draft/date fields it expects are set to the
 * "nothing to show" values, so no banner or date appears.
 */
const AboutPage = () => {
  const [content, setContent] = useState<AboutContent | null>(null);

  useEffect(() => {
    let active = true;
    apiService
      .getAbout()
      .then((loaded) => {
        if (active) setContent(loaded);
      })
      .catch(() => {
        if (active) setContent(UNAVAILABLE_ABOUT);
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <div className="container" style={{ maxWidth: '48rem', padding: '2rem 1rem 4rem' }}>
      <Link to="/" style={{ fontSize: '0.9rem' }}>
        &larr; Back to the home page
      </Link>

      {content === null ? (
        <p style={{ marginTop: '2rem' }}>Loading...</p>
      ) : (
        <LegalDocumentView content={{ ...content, lastUpdated: '', draft: false }} />
      )}
    </div>
  );
};

export default AboutPage;
